const OTP_UI_FALLBACK_MS = 60_000;
const OTP_UI_GRACE_MS = 10_000;

export function otpDeadlineMs(expiresAt: unknown, now = Date.now()): number {
  if (typeof expiresAt === "string") {
    const parsed = Date.parse(expiresAt);
    if (!Number.isNaN(parsed)) return parsed - OTP_UI_GRACE_MS;
  }
  return now + OTP_UI_FALLBACK_MS - OTP_UI_GRACE_MS;
}

export function otpRemainingSeconds(deadlineMs: number, now = Date.now()): number {
  return Math.max(0, Math.ceil((deadlineMs - now) / 1000));
}
